export default __webpack_public_path__ + "assets/96e6e40c2a8ce4ea0bc3a2cb4283c974.png";